/** @module Camunda/TaskCardRenderer */
define([
	"dojo/_base/declare",
	"csi/card/AttributeCardRenderer",
	"csi/locale",
	"csi/core/Key",
	"csi/core/SpecBuilder",
	"./PriorityIconOnTaskRenderer"
], function(declare, AttributeCardRenderer, locale, Key, SpecBuilder, PriorityIconOnTaskRenderer) {

	return declare(AttributeCardRenderer, {
		cardPathToInstance: "Child:C8Instance",

		/**
		 * @override
		 * Specify anchor href and text for attribute card
		 */
		onAttributeCardParams: function(ctx, params) {
			const specBuilder = new SpecBuilder("CamundaTask");
			params.upperRightSpec = specBuilder.getSpecForKey(new Key({id: "DueDate"}));
			params.bottomRightSpec = specBuilder.getSpecForKey(new Key({id: "Priority"}));
			params.bottomRightSpec.heading.classRenderer = PriorityIconOnTaskRenderer;
			params.anchorText = locale.getNodeName(ctx.getNode(), ctx.cache);
		}
	});
});
